module.exports = __webpack_public_path__ + "img/hp1.28452457.png";